import { useSimulatorStore } from '../../stores/useSimulatorStore';
import { FeatureLiftChart } from './FeatureLiftChart';
import { FeatureImpactMatrix } from './FeatureImpactMatrix';
import { BundleOptimizer } from './BundleOptimizer';
import { MarginalValueChart } from './MarginalValueChart';
import { WTPByFeature } from '../wtp/WTPByFeature';
import { WTPBySegment } from '../wtp/WTPBySegment';
import { WTPSummaryTable } from '../wtp/WTPSummaryTable';
import { PackageWTPSummary } from '../wtp/PackageWTPSummary';
import { WTPByDemographic } from '../wtp/WTPByDemographic';
import { PriceValueMap } from '../wtp/PriceValueMap';
import { FeatureAllocationPanel } from './FeatureAllocationPanel';
import { VALID_PRICES } from '../../data/conjointData';
import { formatPrice } from '../../lib/formatters';
import { Select } from '../common/Select';
import { InsightCard } from '../ai/InsightCard';
import { InfoButton } from '../common/Tooltip';

export function FeatureValueTab() {
  const selectedPrice = useSimulatorStore(s => s.selectedPrice);
  const setSelectedPrice = useSimulatorStore(s => s.setSelectedPrice);

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <h2 className="text-lg font-bold text-primary">Feature Value</h2>
        <InfoButton helpKey="wtpTab" size={14} />
      </div>
      <InsightCard tabId="featureValue" />

      <div className="flex items-center gap-4 mb-6">
        <label className="text-sm text-secondary flex items-center gap-1">Reference Price: <InfoButton helpKey="referencePrice" size={11} /></label>
        <Select
          value={selectedPrice}
          options={VALID_PRICES.map(p => ({ value: p, label: formatPrice(p) }))}
          onChange={v => setSelectedPrice(parseInt(v))}
          className="w-40"
        />
      </div>

      {/* Package Value Analysis — how configured packages relate to WTP */}
      <div className="mb-6">
        <PackageWTPSummary />
      </div>

      {/* Feature demand lift ranking + WTP bar chart */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
        <FeatureLiftChart />
        <WTPByFeature />
      </div>

      {/* WTP details with COGS + Marginal value */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
        <WTPSummaryTable />
        <MarginalValueChart />
      </div>

      {/* Price-Value Map + Feature Allocation */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
        <div className="hidden md:block">
          <PriceValueMap />
        </div>
        <FeatureAllocationPanel />
      </div>

      {/* Demographic feature preferences */}
      <div className="mb-6">
        <WTPByDemographic />
      </div>

      {/* Segment WTP ceilings */}
      <div className="mb-6">
        <WTPBySegment />
      </div>

      {/* Deep analysis (desktop) */}
      <div className="hidden md:grid grid-cols-1 xl:grid-cols-2 gap-6">
        <FeatureImpactMatrix />
        <BundleOptimizer />
      </div>
    </div>
  );
}
